<div
  class="tree-item"
  role="treeitem"
  [attr.has-children]="hasSubDirectories(directory()) ? true : null"
  [attr.may-have-children]="hasSubDirectories(directory()) ? true : null"
  [attr.selected]="isSelected() ? true : null"
  [attr.expanded]="expanded(directory()) ? true : null"
  >
  <div class="tree-row"
    [cdkContextMenuTriggerFor]="menu || null"
    [cdkContextMenuTriggerData]="directory()"
    (click)="open(directory())"
    (contextmenu)="onRightClick($event, directory())"
    (dblclick)="toggle($event, directory())"
    [attr.may-have-children]="hasSubDirectories(directory()) ? true : null"
    [style.-webkit-padding-start]="(level() * 20) + 'px'"
    [attr.selected]="isSelected() ? true : null"
    >
    <span class="expand-icon" (click)="toggle($event, directory())"></span>
    <app-folder-icon [item]="directory()" [expanded]="expanded(directory())"></app-folder-icon>
    <span class="tree-label">{{directory().title}}</span>
  </div>
  <div class="tree-children" [attr.expanded]="expanded(directory()) ? true : null">
    @for (child of directory().children; track child.id) {
      <app-tree-item
        [directory]="child"
        [level]="level() + 1"
        [selectedItem]="selectedItem()"
        [menu]="menu"
        [menuComponent]="menuComponent"
        >
      </app-tree-item>
    }
  </div>
</div>
